export enum ENV_VARS {
	HACKETT_USER_AUTH_BASE_URL = 'HACKETT_USER_AUTH_BASE_URL',
	HACKETT_USER_AUTH_SHOW_DEBUG = 'HACKETT_USER_AUTH_SHOW_DEBUG',
	HACKETT_USER_AUTH_USE_REAL_AUTH = 'HACKETT_USER_AUTH_USE_REAL_AUTH',
	HACKETT_USER_AUTH_AMPLIFY_REGION = 'HACKETT_USER_AUTH_AMPLIFY_REGION',
	HACKETT_USER_AUTH_AMPLIFY_USER_POOL_ID = 'HACKETT_USER_AUTH_AMPLIFY_USER_POOL_ID',
	HACKETT_USER_AUTH_AMPLIFY_USER_POOL_WEB_CLIENT_ID = 'HACKETT_USER_AUTH_AMPLIFY_USER_POOL_WEB_CLIENT_ID',
	HACKETT_USER_AUTH_PACKAGE_VERSION = 'HACKETT_USER_AUTH_PACKAGE_VERSION',
	HACKETT_USER_AUTH_BLOG_URL = 'HACKETT_USER_AUTH_BLOG_URL',
	HACKETT_USER_AUTH_REMEMBER_DEVICE_ENABLED = 'HACKETT_USER_AUTH_REMEMBER_DEVICE_ENABLED',
	HACKETT_USER_AUTH_REMEMBER_DEVICE_DURATION_IN_DAYS = 'HACKETT_USER_AUTH_REMEMBER_DEVICE_DURATION_IN_DAYS',
	HACKETT_USER_AUTH_INSTANCE = 'HACKETT_USER_AUTH_INSTANCE',
	HACKETT_ACTION_TRACKING_ENABLED = 'HACKETT_ACTION_TRACKING_ENABLED',
	SENTRY_DSN = 'SENTRY_DSN',
}

export enum INSTANCES {
	HC = 'HC',
	QL = 'QL',
}
